import { styleGuides } from "@/mocks/gallery";
import Reveal from "@/pages/home/components/Reveal";

export default function StyleGuide() {
  return (
    <section id="guide" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="max-w-3xl mb-10">
            <span className="text-xs font-label tracking-widest text-primary-600 uppercase">Style Guide</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">风格指南</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-700">
              不同类型的合集在光线、构图、配色与尺寸上各有侧重。了解这四个维度，就能更快判断哪一类内容更符合自己的偏好，也让浏览更有方向。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {styleGuides.map((guide, index) => (
            <Reveal key={guide.id} delay={index * 70}>
              <article className="h-full rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6 hover:border-accent-300 transition-colors">
                <span className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center text-accent-700">
                  <i className={`${guide.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{guide.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{guide.desc}</p>
                <ul className="mt-4 space-y-2">
                  {guide.points.map((point) => (
                    <li key={point} className="flex items-start gap-2 text-xs text-foreground-700">
                      <i className="ri-check-line text-primary-600 mt-0.5"></i>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}